const ActionTypes =  {
    SET_PRODUCTS: "SET_PRODUCTS",
    SELECTED_PRODUCT: "SELECTED_PRODUCT",
    REMOVE_PRODUCT: "REMOVE_PRODUCT",
    SET_PRODUCT_BY_CATEGORY: "SET_PRODUCT_BY_CATEGORY",
    SET_USERS: "SET_PRODUCTS",
};

export { ActionTypes };

